import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  admin,
  announce,
  announcement,
  apptime,
  blockuser,
  deletedata,
  help,
  history,
  link,
  overall,
  publicactivity,
  recharge,
  report,
  toggle_off,
  toggle_on,
  winning,
  withdraw,
  withdrawIcon,
} from "../../assets/img";
import Footer from "../../Component/Footer/Footer";
import SubmitButton from "../../Component/SubmitButton";
import { get, post } from "../../Services/ApiHandler";


import { Toast } from "../../Component/Toast";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import CommonPopup from "../../Component/CommonPopup";
import { MaskIcon } from "../../Component/MaskIcon";

const RoleUpdate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type || "add";
  const data = location?.state?.data || [];
  const { kv, set } = useStoreKv();
  const RoleUpdate = kv.roleupdate || [];

  const profiledata = [
    { id: 1, icon: admin, title: "Dashboard" },
    { id: 2, icon: admin, title: "Admins" },
    { id: 3, icon: admin, title: "Roles Mapping" },
    { id: 4, icon: admin, title: "Clients" },
    { id: 5, icon: recharge, title: "Admin Recharge" },
    { id: 6, icon: history, title: "Recharge History" },
    { id: 7, icon: withdrawIcon, title: "Withdraw History" },
    { id: 8, icon: announce, title: "Announce Result" },
    { id: 9, icon: overall, title: "Overall Results" },
    { id: 10, icon: report, title: "Reports" },
    { id: 11, icon: overall, title: "Commission History" },
    { id: 12, icon: winning, title: "Announcement" },
    { id: 13, icon: winning, title: "Holiday Update" },
    { id: 14, icon: link, title: "Links" },
    { id: 15, icon: overall, title: "Lot Price Details" },
    { id: 16, icon: overall, title: "Price Details" },
    { id: 17, icon: apptime, title: "App Time Settings" },
    { id: 18, icon: help, title: "Help & Support" },
    { id: 19, icon: deletedata, title: "Delete Data" },
    { id: 20, icon: publicactivity, title: "Client Activity" },
    { id: 21, icon: blockuser, title: "Blocked Client List" },
    { id: 22, icon: overall, title: "Draw Status" },
  ];

  const [formData, setFormData] = useState({
    Name: data?.name || "",
  });

  const [roleToggles, setRoleToggles] = useState(() => {
    // 1️⃣ If KV already has data → use it
    if (RoleUpdate && Object.keys(RoleUpdate).length > 0) {
      return RoleUpdate;
    }

    // 2️⃣ Otherwise create default false toggles
    return profiledata.reduce((acc, _, idx) => {
      acc[idx] = false;
      return acc;
    }, {});
  });

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [popup, setPopup] = useState(false);
  // --- Fetch Role Permissions ---
  const getRoleList = async () => {
    if (!data?.id) return;

    if (!kv.roleupdate || kv.roleupdate.length === 0) {
      setLoading(true);
    }

    try {
      const res = await get(`${data?.id}/permissions`);
      // console.log("Fetched roles:", res);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        const updatedToggles = profiledata.reduce((acc, item, idx) => {
          const perm = res.data.find(
            (p) => p.id === item.id && p.permission === true
          );
          acc[idx] = !!perm;
          // console.log("acc", acc);

          return acc;
        }, {});
        setRoleToggles(updatedToggles);
        set('roleupdate', updatedToggles);
      } else {
        Toast("No role permissions found");
        setRoleToggles({});
        set('roleupdate', {});
      }
    } catch (err) {
      console.error("Error fetching role list:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (type === "edit") getRoleList();
  }, [data?.id, type]);

  // --- Toggle Functions ---
  const allSelected = Object.values(roleToggles).every((v) => v === true);

  const toggleRole = (index) => {
    setRoleToggles((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleSelectAll = () => {
    const newState = !allSelected;
    const updated = Object.keys(roleToggles).reduce((acc, key) => {
      acc[key] = newState;
      return acc;
    }, {});
    setRoleToggles(updated);
  };

  // --- Submit Handler ---
  const handleSubmit = async () => {
    setLoading1(true)
    try {
      if (!data?.id) {
        console.error("Missing admin ID!");
        return;
      }

      // Convert roleToggles into the required format
      const modules = {};
      Object.keys(roleToggles).forEach((key, index) => {
        modules[index + 1] = roleToggles[key];
      });

      const payload = {
        id: data?.id,
        modules,
      };

      // console.log("Updating permissions payload:", payload);

      const res = await post(`${data?.id}/permissions`, payload);

      if (res?.status === "success") {
        Toast("Permissions updated successfully!");
        setPopup(false);
        navigate("/role", { replace: true });
        setLoading1(false)
      } else {
        Toast(res?.message || "Failed to update roles");
        setLoading1(false)
      }
    } catch (err) {
      console.error("Error updating roles:", err);
      Toast("Something went wrong while updating roles.");
      setLoading1(false)
    } finally {
      setLoading1(false);
      setPopup(false);
    }
  };

  return (
    <div className="dashRightView" >
      <CustomScroll>
        <div className="container_overalls" style={{paddingTop:0}}>
          <p className="f3 admin_title fs-sm-15 fs-md-16 fs-lg-18 fs-xl-19 fs-xxl-21 my-3">
            {type === "add" ? "Add Admin" : "Edit Admin"}
          </p>

          <div className="col-md-5">
            <p className="f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 primary">
              Admin Name
            </p>
            <input
              className="input-box f2 fs-xs-15 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 placholdercolorchanges2"
              name="Name"
              style={{ color: '#575757' }}
              value={formData.Name}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, Name: e.target.value }))
              }
              type="text"
              placeholder="User Name"
              disabled={type === "edit"}
            />
          </div>

          <div
            className="d-flex ac-je gap-3 col-md-5"

            style={{ cursor: "pointer", alignItems: "center" }}
          >
            {allSelected ? (
              <div className="custom-toggle-on" onClick={toggleSelectAll}>
                <div className="custom-toggle-thumb-on" />
              </div>
            ) : (
              <div className="custom-toggle-off" onClick={toggleSelectAll}>
                <div className="custom-toggle-thumb-off" />
              </div>
            )}
            <p className="f3 fs-xs-15 fs-sm-16 fs-md-16 fs-lg-16 fs-xl-16 fs-xxl-16 my-3">
              Select All
            </p>
          </div>

          {loading ? (
            <p className="text-center my-4">Loading roles...</p>
          ) : (
            <div className="profile-list col-md-5">
              {profiledata.map((item, index) => (
                <div
                  className="d-flex ac-jb py-3 profile-item"
                  key={index}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex ac-js gap-3">
                    <MaskIcon src={item.icon} height={15} width={15} alt="icon" />
                    <p className="f3 fs-xs-15 fs-sm-16 fs-md-15 fs-lg-18 fs-xl-21 fs-xxl-18 primary mb-0">
                      {item.title}
                    </p>
                  </div>
                  <div onClick={() => toggleRole(index)}>
                    {roleToggles[index] ? (
                      <div className="custom-toggle-on">
                        <div className="custom-toggle-thumb-on" />
                      </div>
                    ) : (
                      <div className="custom-toggle-off">
                        <div className="custom-toggle-thumb-off" />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={{ marginBottom: 80 }} className="col-md-5s">
            {/* <button
              onClick={() => setPopup(true)}
              className="add-button f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 white my-3"
            >Update</button> */}
            <SubmitButton
              onClick={() => setPopup(true)}
              title="Update"
              disabled={loading}
              isFormValid={loading}
              className="mt-3"
              width={true}
            />
          </div>
        </div>
      </CustomScroll>
      <Footer />
      <CommonPopup
        isOpen={popup}
        message="Are you sure, you want to Update ?"
        onClose={() => setPopup(false)}
        onConfirm={handleSubmit}
        loading={loading1}
      />

    </div>
  );
};

export default RoleUpdate;
